// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: any = {
  production: false,
  authApiUrl: 'https://trumisdev.truminds.co.in/api',
  projectApiUrl: 'https://trumisdev.truminds.co.in/api',
  employeeApiUrl: 'https://trumisdev.truminds.co.in/api',
  clientApiUrl: 'https://trumisdev.truminds.co.in/api',
  reportApiUrl: 'https://trumisdev.truminds.co.in/api',
  assetApiUrl: 'https://trumisdev.truminds.co.in/api',
  apiUrl: 'http://localhost:8080/api',
  dashboardApiUrl: 'https://trumisdev.truminds.co.in/api',
  campusApiUrl: 'https://trumisdev.truminds.co.in/api',
  vendorApiUrl: 'https://trumisdev.truminds.co.in/api',
  expenseApiUrl: 'https://trumisdev.truminds.co.in/api',
  helpDeskApiUrl: 'https://trumisdev.truminds.co.in/api',
  learnDevelopmentApiUrl: 'https://trumisdev.truminds.co.in/api',
  msalConfig: {
    clientId: '32c65716-9d27-4284-ab6c-7b1504b814db', // Replace with your client ID
    authority: `https://login.microsoftonline.com/organization/B2C_1A_TRUMINDSSIGNIN/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}/login`, 
    postLogoutRedirectUri: 'http://localhost:4200', // post-logout redirect URI
  },
  cacheConfig: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  extras: {
   b2cDomain:'truiamauth.b2clogin.com',//B2C_Domain
	 b2cTenantName: 'truiamauth.onmicrosoft.com',//B2C_TenantName
	 b2cPolicy: 'B2C_1A_TRUMINDSSIGNIN',//B2C_policy
	 applicationClientId: '32c65716-9d27-4284-ab6c-7b1504b814db',//application_client_Id
	 scope: 'openid',
	 responseToken: 'id_token' 
  },
  chatBotKey: 'DUMMY_DEV_KEY' //dev

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
